var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`has-tag ${_vm.selected ? 'selected' : _vm.aptitude}`},[_vm._v("\n  "+_vm._s(`${_vm.lot.area} has`)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }